import React, { useState } from "react";

import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import StepContent from "@mui/material/StepContent";
import Paper from "@mui/material/Paper";
import { Link } from "react-router-dom";

function Calcular() {
	const [activeStep, setActiveStep] = useState(0);
  
	const handleNext = () => {
		setActiveStep((prevActiveStep) => prevActiveStep + 1);
	};

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};

	const handleReset = () => {
		setActiveStep(0);
	};

	return (
		<div>
			<h1>Como calcular seu Grau de Inovação?</h1>
			<hr />
			<div className="d-flex justify-content-center">
				<Box sx={{ maxWidth: 400 }}>
					<Stepper activeStep={activeStep} orientation="vertical">
						<Step>
							<StepLabel>Entre em contato com a gente!</StepLabel>
							<StepContent>
								<Typography>
									Envie um e-mail para{" "}
									<b>nit@univasf.edu.br</b> para saber mais
									informações sobre acesso a plataforma,
									preços, consultorias e entre outros.
								</Typography>
								<Box sx={{ mb: 2 }}>
									<div>
										<Button
											variant="contained"
											onClick={handleNext}
											sx={{ mt: 1, mr: 1 }}
										>
											{activeStep === 3
												? "Fim"
												: "Próximo"}
										</Button>
										<Button
											disabled={activeStep === 0}
											onClick={handleBack}
											sx={{ mt: 1, mr: 1 }}
										>
											Voltar
										</Button>
									</div>
								</Box>
							</StepContent>
						</Step>
						<Step>
							<StepLabel>Acesso a plataforma</StepLabel>
							<StepContent>
								<Typography>
									Será liberado o acesso a plataforma por meio
									de um e-mail válido.
								</Typography>
								<Box sx={{ mb: 2 }}>
									<div>
										<Button
											variant="contained"
											onClick={handleNext}
											sx={{ mt: 1, mr: 1 }}
										>
											{activeStep === 3
												? "Fim"
												: "Próximo"}
										</Button>
										<Button
											disabled={activeStep === 0}
											onClick={handleBack}
											sx={{ mt: 1, mr: 1 }}
										>
											Voltar
										</Button>
									</div>
								</Box>
							</StepContent>
						</Step>
						<Step>
							<StepLabel>
								Faça seu cadastro na plataforma.
							</StepLabel>
							<StepContent>
								<Typography>
									Com seu e-mail que foi informado, acesse a
									página de{" "}
									<Link to="cadastre-se">Cadastre-se</Link> e
									realize o seu cadastro de acordo com seu
									perfil.
								</Typography>
								<Box sx={{ mb: 2 }}>
									<div>
										<Button
											variant="contained"
											onClick={handleNext}
											sx={{ mt: 1, mr: 1 }}
										>
											{activeStep === 3
												? "Fim"
												: "Próximo"}
										</Button>
										<Button
											disabled={activeStep === 0}
											onClick={handleBack}
											sx={{ mt: 1, mr: 1 }}
										>
											Voltar
										</Button>
									</div>
								</Box>
							</StepContent>
						</Step>
						<Step>
							<StepLabel>Calcule seu Grau de Inovação.</StepLabel>
							<StepContent>
								<Typography>
									Acesse a sua conta e calcule seu Grau de
									Inovação.
								</Typography>
								<Box sx={{ mb: 2 }}>
									<div>
										<Button
											variant="contained"
											onClick={handleNext}
											sx={{ mt: 1, mr: 1 }}
										>
											{activeStep === 3
												? "Fim"
												: "Próximo"}
										</Button>
										<Button
											disabled={activeStep === 0}
											onClick={handleBack}
											sx={{ mt: 1, mr: 1 }}
										>
											Voltar
										</Button>
									</div>
								</Box>
							</StepContent>
						</Step>
					</Stepper>

					{activeStep === 4 && (
						<Paper square elevation={0} sx={{ p: 3 }}>
							<Typography>Todos os passos concluidos!</Typography>
							<Button onClick={handleReset} sx={{ mt: 1, mr: 1 }}>
								Recomeçar
							</Button>
						</Paper>
					)}
				</Box>
			</div>
		</div>
	);
}

export default Calcular;
